module.exports = __webpack_public_path__ + "static/media/s2.9b1745d7.webp";